import { createReducer } from '@reduxjs/toolkit';
import {
  getInPersonEventCheckInQr,
  inPersonEventConfirmAttendance,
  inPersonEventCheckIn,
} from 'redux/actions/in-person-events';
import { initialRootState } from '.';

export default createReducer(initialRootState, builder => {
  builder
    .addCase(getInPersonEventCheckInQr.fulfilled, (state, action) => {
      const { sessionId } = action.meta.arg;
      const session = state.models.inPersonEventSessions[sessionId];
      if (session) {
        session.qrCodeUrl = action.payload;
      }
    })
    .addCase(inPersonEventConfirmAttendance.fulfilled, (state, action) => {
      const { sessionId } = action.meta.arg;
      const session = state.models.inPersonEventSessions?.[sessionId];
      if (session) {
        session.status = action.payload.status;
        session.confirmedRegistration = action.payload.confirmedRegistration;
      }
    })
    .addCase(inPersonEventCheckIn.fulfilled, (state, action) => {
      const { sessionId, passcode } = action.meta.arg;
      const session = state.models.inPersonEventSessions[sessionId];
      if (session && passcode) {
        session.status = action.payload.status;
      }
    });
});
